import { UAParser } from './index';
import { parse } from '@utils/query-string';

/**
 * 判断微信小程序环境
 */
export const isInMiniProgram = () => {
  const { wxMiniProgram } = UAParser();
  return wxMiniProgram;
};

/**
 * 判断星喜环境
 */
export const isInFosun = () => {
  const fosun = parse(window.location.search)?.fosun || '';
  return fosun == 1;
};

/**
 * 判断微信浏览器
 */
export const isInWechat = () => {
  const { Wechat } = UAParser();
  return Wechat;
};
